import { hasDealerContext } from 'utils/hasDealerContext';
import { parseCalendarDateFromApi } from 'utils/dateUtils';

export function dealerHasLaunchDateField(dealer: unknown): boolean {
  return (
    typeof dealer === 'object' &&
    dealer !== null &&
    Object.prototype.hasOwnProperty.call(dealer, 'launch_date')
  );
}

export function resolveDealerLaunchDateRaw(dealer: unknown): string | null {
  if (!dealerHasLaunchDateField(dealer)) {
    return null;
  }

  const raw = (dealer as { launch_date: unknown }).launch_date;
  if (raw == null || raw === '') {
    return null;
  }
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    return trimmed || null;
  }
  if (raw instanceof Date) {
    return Number.isNaN(raw.getTime()) ? null : raw.toISOString();
  }
  const asString = String(raw).trim();
  return asString || null;
}

export function hasDealerLaunchDate(dealer: unknown): boolean {
  if (!hasDealerContext(dealer)) {
    return false;
  }
  if (!dealerHasLaunchDateField(dealer)) {
    return false;
  }

  const launchDateRaw = resolveDealerLaunchDateRaw(dealer);
  if (!launchDateRaw) {
    return false;
  }

  return Boolean(parseCalendarDateFromApi(launchDateRaw)?.isValid);
}
